export const projects = [
  {
    id: "knewit",
    title: {
      en: "Knewit - Prediction Market Platform",
      zh: "懂了 - 预测市场平台",
      ja: "Knewit - 予測市場プラットフォーム",
    },
    date: {
      en: "Dec 2024 - May 2025",
      zh: "2024年12月 - 2025年5月",
      ja: "2024年12月 - 2025年5月",
    },
    description: {
      en: "A product-focused prediction market platform built from MVP to a microservices-based system with real-time event processing and social forecasting loops.",
      zh: "一个从 MVP 演进到微服务架构的产品型预测市场平台，具备实时事件处理与社交化预测闭环。",
      ja: "MVP からマイクロサービス構成へ発展した、リアルタイム処理とソーシャル予測ループを持つプロダクト志向の予測市場プラットフォーム。",
    },
    featuredSummary: {
      en: "Built the platform end-to-end across product iteration, backend architecture, and real-time data flow. The system evolved from a mini program into a prediction market stack using Spring Boot, Kafka, Redis, MySQL, and React Native.",
      zh: "从产品迭代、后端架构到实时数据链路，端到端参与了整个平台建设。系统从小程序演进为基于 Spring Boot、Kafka、Redis、MySQL 和 React Native 的预测市场架构。",
      ja: "プロダクト反復、バックエンド設計、リアルタイムデータフローまでエンドツーエンドで構築。ミニプログラムから Spring Boot、Kafka、Redis、MySQL、React Native を用いた予測市場スタックへ発展させた。",
    },
    role: {
      en: "Role: End-to-end builder across backend architecture, market product flows, and infrastructure evolution.",
      zh: "角色：覆盖后端架构、市场产品流程与基础设施演进的端到端构建者。",
      ja: "役割: バックエンド設計、マーケットプロダクトフロー、基盤進化まで担うエンドツーエンドの実装者。",
    },
    metric: {
      en: "~1,000 DAU during live usage and product validation",
      zh: "上线与产品验证阶段约 1,000 DAU",
      ja: "公開運用と検証段階で約 1,000 DAU",
    },
    focusAreas: {
      en: [
        "Prediction market user flows with market creation, trading, and community interaction",
        "Microservices architecture for real-time processing with Kafka and Redis",
        "Mobile product delivery with React Native backed by Spring Boot services",
      ],
      zh: [
        "覆盖建市场、交易、互动的预测市场用户流程",
        "基于 Kafka 和 Redis 的实时处理微服务架构",
        "React Native 移动端与 Spring Boot 服务端协同交付",
      ],
      ja: [
        "市場作成、取引、コミュニティ参加まで含む予測市場 UX",
        "Kafka と Redis を用いたリアルタイム処理マイクロサービス構成",
        "React Native モバイル体験と Spring Boot サービスの連携",
      ],
    },
    technologies: [
      "React Native",
      "Spring Boot",
      "Kafka",
      "Redis",
      "Docker",
      "Kubernetes",
      "MySQL",
    ],
    image: "/assets/projects/Knewit/cover.png",
    link: "https://dongleapp.com/",
    featured: true,
  },
  {
    id: "wealth-app",
    title: {
      en: "Wealth App Prototype",
      zh: "财富管理应用原型",
      ja: "ウェルスアプリのプロトタイプ",
    },
    date: {
      en: "Nov 2025",
      zh: "2025年11月",
      ja: "2025年11月",
    },
    context: {
      en: "Hackathon",
      zh: "Hackathon",
      ja: "Hackathon",
    },
    description: {
      en: "Built a fintech product prototype around onboarding, portfolio tracking, savings simulation, and AI-assisted investing flows during a rapid product sprint.",
      zh: "在一次高强度产品型 hackathon 中完成了一个金融应用原型，覆盖 onboarding、组合跟踪、储蓄模拟与 AI 辅助投资流程。",
      ja: "短期のプロダクト系ハッカソンで、オンボーディング、ポートフォリオ追跡、貯蓄シミュレーション、AI 支援投資フローを備えたフィンテック原型を構築。",
    },
    technologies: [
      "Next.js",
      "TypeScript",
      "Tailwind CSS",
      "Recharts",
      "Vercel",
    ],
    image: "/assets/projects/Wealth/logo.png",
    link: "https://ethglobal.com/showcase/wealth-60jtz",
  },
  {
    id: "markfair",
    title: {
      en: "MarkFair",
      zh: "MarkFair",
      ja: "MarkFair",
    },
    date: {
      en: "Starknet Hackathon 2025",
      zh: "Starknet Hackathon 2025",
      ja: "Starknet Hackathon 2025",
    },
    context: {
      en: "Hackathon",
      zh: "Hackathon",
      ja: "Hackathon",
    },
    description: {
      en: "Built the contract side of a Web3 marketing escrow system with attribution and epoch settlement, combining Cairo contracts with FastAPI and React dashboards.",
      zh: "在 Starknet Hackathon 中完成了一个 Web3 营销托管与归因系统的合约侧实现，并与 FastAPI 服务和 React 控制台配合完成 epoch 结算流程。",
      ja: "Starknet Hackathon で、Web3 マーケティング向けエスクローとアトリビューション基盤のコントラクト側を構築し、FastAPI と React ダッシュボードと組み合わせて epoch 精算まで仕上げた。",
    },
    technologies: [
      "Cairo",
      "Starknet",
      "FastAPI",
      "React",
      "Merkle Tree",
      "Clerk",
    ],
    image: "/assets/projects/Markfair/markfair_logo.png",
    link: "https://devpost.com/software/markfair",
  },
  {
    id: "crypto-agent",
    title: {
      en: "Crypto Trading Agent System",
      zh: "加密货币交易代理系统",
      ja: "暗号通貨取引エージェントシステム",
    },
    date: {
      en: "Jan 2023 - May 2023",
      zh: "2023年1月 - 5月",
      ja: "2023年1月 - 5月",
    },
    description: {
      en: "A modular automated trading framework combining technical, on-chain, sentiment, and risk analysis through a multi-agent workflow.",
      zh: "一个模块化的自动化交易框架，通过多代理工作流整合技术面、链上、情绪和风险分析。",
      ja: "テクニカル、オンチェーン、センチメント、リスク分析をマルチエージェントで統合した自動売買フレームワーク。",
    },
    technologies: [
      "Python",
      "Machine Learning",
      "Blockchain",
      "Technical Analysis",
      "Data Visualization",
      "Multi-agent System",
    ],
    image: "/assets/projects/CryptoAgent/cover.png",
    link: "/projects/crypto-agent",
  },
  {
    id: "evrald",
    title: {
      en: "EVRALD - Business Intelligence System",
      zh: "EVRALD - 智能商业数据分析系统",
      ja: "EVRALD - スマートビジネスインテリジェンスシステム",
    },
    date: {
      en: "Jun 2023 - Aug 2024",
      zh: "2023年6月 - 2024年8月",
      ja: "2023年6月 - 2024年8月",
    },
    description: {
      en: "A business intelligence and risk analytics platform focused on faster enterprise decision support and data visibility.",
      zh: "一个面向企业更快决策支持与数据可视化的商业智能和风险分析平台。",
      ja: "企業の意思決定支援とデータ可視化を目的としたビジネスインテリジェンス / リスク分析プラットフォーム。",
    },
    technologies: [
      "React",
      "TailwindCSS",
      "Spring Boot",
      "MySQL",
      "Redis",
      "Docker",
      "Machine Learning",
    ],
    image: "/assets/projects/Evrald/cover.jpg",
    link: "/projects/evrald",
  },
  {
    id: "zksnark",
    title: {
      en: "zk-SNARK - Delivery Feasibility Proof System",
      zh: "zk-SNARK - 物流可行性证明系统",
      ja: "zk-SNARK - 配送実現可能性証明システム",
    },
    date: {
      en: "Jul 2024 - Aug 2024",
      zh: "2024年7月 - 8月",
      ja: "2024年7月 - 8月",
    },
    description: {
      en: "A privacy-preserving proof system for verifying delivery feasibility without exposing sensitive logistics data.",
      zh: "一个在不暴露敏感物流数据前提下验证交付可行性的隐私证明系统。",
      ja: "機密物流データを公開せずに配送実現性を検証するプライバシー保護型証明システム。",
    },
    technologies: [
      "Circom 2.0",
      "snarkjs",
      "Solidity",
      "Hardhat",
      "Next.js",
      "React",
    ],
    image: "/assets/projects/zksnark/cover.png",
    link: "/projects/zksnark",
  },
  {
    id: "chatterbox",
    title: {
      en: "Chatterbox - Secure Communication Protocol",
      zh: "Chatterbox - 安全通信协议",
      ja: "Chatterbox - セキュア通信プロトコル",
    },
    date: {
      en: "Nov 2024 - Dec 2024",
      zh: "2024年11月 - 2024年12月",
      ja: "2024年11月 - 2024年12月",
    },
    description: {
      en: "An end-to-end encrypted messaging system inspired by Signal Protocol and implemented across Go, React, and WebAssembly.",
      zh: "一个受 Signal Protocol 启发、以 Go、React 和 WebAssembly 实现的端到端加密通信系统。",
      ja: "Signal Protocol に着想を得て、Go、React、WebAssembly で実装したエンドツーエンド暗号化メッセージングシステム。",
    },
    technologies: [
      "Go",
      "React",
      "WebAssembly",
      "AES-GCM",
      "ECDH",
      "Double Ratchet",
    ],
    image: "/assets/projects/chatterbox/cover.png",
    link: "/projects/chatterbox",
  },
  {
    id: "dhow",
    title: {
      en: "Dhow.cn - Art Blockchain Platform",
      zh: "Dhow.cn - 艺术品区块链平台",
      ja: "Dhow.cn - アートブロックチェーンプラットフォーム",
    },
    date: {
      en: "Sep 2023 - Feb 2024",
      zh: "2023年9月 - 2024年2月",
      ja: "2023年9月 - 2024年2月",
    },
    description: {
      en: "A blockchain platform connecting Chinese artists with global collectors, designed around transparency and cross-border trust.",
      zh: "一个连接中国艺术家与全球收藏家的区块链平台，围绕透明度与跨境信任设计。",
      ja: "透明性と越境信頼を重視して設計された、中国人アーティストと世界中のコレクターをつなぐブロックチェーンプラットフォーム。",
    },
    technologies: ["Vue.js", "Django", "MySQL", "Blockchain", "i18n"],
    image: "/assets/projects/dhow/cover.jpg",
    link: "/projects/dhow",
  },
  {
    id: "weensyos",
    title: {
      en: "WeensyOS - Minimal Operating System",
      zh: "WeensyOS - 微型操作系统",
      ja: "WeensyOS - ミニマルオペレーティングシステム",
    },
    date: {
      en: "Mar 2025 - Apr 2025",
      zh: "2025年3月 - 4月",
      ja: "2025年3月 - 4月",
    },
    description: {
      en: "An educational operating system project focused on virtual memory, process isolation, and kernel-level memory protection.",
      zh: "一个聚焦虚拟内存、进程隔离和内核级内存保护的教学型操作系统项目。",
      ja: "仮想メモリ、プロセス分離、カーネルレベルのメモリ保護に焦点を当てた教育用 OS プロジェクト。",
    },
    technologies: [
      "C",
      "x86-64 Assembly",
      "Virtual Memory",
      "QEMU",
      "Operating Systems",
    ],
    image: "/assets/projects/WeensyOS/shared_read_only_memory.gif",
    link: "/projects/weensyos",
  },
  {
    id: "binarystar",
    title: {
      en: "Binary Star System - Physics Simulation",
      zh: "双星系统 - 物理模拟",
      ja: "連星システム - 物理シミュレーション",
    },
    date: {
      en: "Feb 2024 - Mar 2024",
      zh: "2024年2月 - 3月",
      ja: "2024年2月 - 3月",
    },
    description: {
      en: "A numerical simulation of binary star dynamics and debris capture using Runge-Kutta integration.",
      zh: "一个基于 Runge-Kutta 积分的双星动力学与碎片捕获数值模拟项目。",
      ja: "Runge-Kutta 積分を用いて連星の運動とデブリ捕獲をシミュレーションしたプロジェクト。",
    },
    technologies: ["Matlab", "Physics Simulation", "Numerical Methods"],
    image: "/assets/projects/binaryStarSystem/cover.gif",
    link: "/projects/binarystar",
  },
  {
    id: "blackdeath",
    title: {
      en: "Black Death - Pandemic Simulation",
      zh: "黑死病 - 疫情传播模拟",
      ja: "ペスト - パンデミックシミュレーション",
    },
    date: {
      en: "Mar 2024 - Apr 2024",
      zh: "2024年3月 - 4月",
      ja: "2024年3月 - 4月",
    },
    description: {
      en: "A disease spread simulation across medieval trade routes using epidemiological and visualization models.",
      zh: "一个基于流行病学模型与可视化方法模拟中世纪贸易路线疾病传播的项目。",
      ja: "疫学モデルと可視化を用いて中世の交易路における感染拡大を再現したシミュレーション。",
    },
    technologies: ["Matlab", "Epidemiology", "Data Visualization"],
    image: "/assets/projects/blackDeathSimulation/cover.jpg",
    link: "/projects/blackdeath",
  },
  {
    id: "musicclassification",
    title: {
      en: "Spotify - Music Genre Classification",
      zh: "Spotify - 音乐流派分类",
      ja: "Spotify - 音楽ジャンル分類",
    },
    date: {
      en: "Apr 2024 - May 2024",
      zh: "2024年4月 - 5月",
      ja: "2024年4月 - 5月",
    },
    description: {
      en: "A machine learning project classifying tracks into genres using Spotify audio features and model comparison.",
      zh: "一个利用 Spotify 音频特征进行音乐流派分类并比较模型表现的机器学习项目。",
      ja: "Spotify の音響特徴量を使って音楽ジャンルを分類し、モデル比較を行った機械学習プロジェクト。",
    },
    technologies: [
      "Python",
      "Scikit-learn",
      "Neural Networks",
      "PCA",
      "t-SNE",
      "Data Visualization",
    ],
    image: "/assets/projects/musicClassification/tsne_clusters.png",
    link: "/projects/musicclassification",
  },
  {
    id: "sketchinglsq",
    title: {
      en: "Sketching for Least Squares Problem",
      zh: "最小二乘问题的降维技术",
      ja: "最小二乗問題のためのスケッチング",
    },
    date: {
      en: "Nov 2024 - Dec 2024",
      zh: "2024年11月 - 12月",
      ja: "2024年11月 - 12月",
    },
    description: {
      en: "A study of sketching-based dimensionality reduction for solving large-scale least squares problems more efficiently.",
      zh: "一个研究基于 sketching 的降维方法以更高效求解大规模最小二乘问题的项目。",
      ja: "大規模最小二乗問題をより効率よく解くための sketching ベース次元削減手法の研究。",
    },
    technologies: [
      "Python",
      "NumPy",
      "SciPy",
      "Pandas",
      "Matplotlib",
      "Linear Algebra",
    ],
    image: "/assets/projects/sketchingLeastSquares/main_image.png",
    link: "/projects/sketchinglsq",
  },
];

export const featuredProject = projects.find((project) => project.featured);
export const archivedProjects = projects.filter((project) => !project.featured);
